import(/* webpackMode: "eager" */ "/vercel/path0/app/(marketing)/page.tsx");
